import { logger } from '../../src/app/utils/logger';
/* Clerk configuration — loaded exclusively from environment variables.
   Never hardcode publishable keys here. Set VITE_CLERK_PUBLISHABLE_KEY
   in your .env file (see .env.example). */

export const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string;

if (!clerkPublishableKey) {
  logger.error(
    '[Clerk] Missing VITE_CLERK_PUBLISHABLE_KEY environment variable. ' +
    'Set it in your .env file (see .env.example).'
  );
}

export const isClerkConfigured = () => !!clerkPublishableKey;
